import React from 'react';
import { useCurrentEditor } from '@tiptap/react';
import { ulid } from 'ulid';

import {
  CONDITIONAL_SECTION_NODE,
  useConditionalSections,
} from '~/components/core/Editor/extensions/ConditionalSection';

import ToolbarButton from '../ToolbarButton';

/** Wraps the selected blocks in a new conditional section, then asks the owner for its condition. */
const ConditionalSectionButton: React.FC = () => {
  const { editor } = useCurrentEditor();
  const context = useConditionalSections();

  if (!editor || !context?.canEditConditions) {
    return null;
  }

  const wrap = () => {
    const key = ulid();
    if (editor.chain().focus().wrapIn(CONDITIONAL_SECTION_NODE, { sectionKey: key }).run()) {
      context.onCreate(key);
    }
  };

  return (
    <ToolbarButton onClick={wrap} disabled={!editor.can().wrapIn(CONDITIONAL_SECTION_NODE)} className="px-8 text-sm">
      Show only if…
    </ToolbarButton>
  );
};

export default ConditionalSectionButton;
